import type VectorSource from 'ol/source/Vector';
import type { SimpleGeometry } from 'ol/geom';
import type Feature from 'ol/Feature';

export const IGNORE_REMOVE_EVENT_NAME = 'shouldIgnoreRemoveEvent';
export const IGNORE_ADD_EVENT_NAME = 'shouldIgnoreAddEvent';
type SUPPORTED_FLAGS = typeof IGNORE_REMOVE_EVENT_NAME | typeof IGNORE_ADD_EVENT_NAME;

export function clearSourceIgnoringRemoveEvent (source: VectorSource<SimpleGeometry>) {
  doOperationWithSourceFlagSet(source, () => source.clear(), IGNORE_REMOVE_EVENT_NAME);
}

export function removeFeatureIgnoringRemoveEvent (feature: Feature<SimpleGeometry>, source: VectorSource<SimpleGeometry>) {
  doOperationWithSourceFlagSet(source, () => source.removeFeature(feature), IGNORE_REMOVE_EVENT_NAME);
}

export function addFeaturesIgnoringAddEvent (features: Feature<SimpleGeometry>[], source: VectorSource<SimpleGeometry>) {
  doOperationWithSourceFlagSet(source, () => source.addFeatures(features), IGNORE_ADD_EVENT_NAME);
}

function doOperationWithSourceFlagSet (source: VectorSource<SimpleGeometry>, sourceOperationFn: (source: VectorSource<SimpleGeometry>) => void, flagName: SUPPORTED_FLAGS) {
  source.set(flagName, true, true);
  sourceOperationFn(source);
  source.unset(flagName, true);
}
